import { ExecutionResults } from 'api/Exec/types';
import { borderColorSplit } from 'app/consts/colors';

import { Flex, Form, Checkbox, Typography } from 'antd';
import React from 'react';

interface Props {
  results: ExecutionResults | null;
  viewMode?: boolean;
}

const ExecutionResultsForm: React.FC<Props> = ({ results, viewMode = false }) => {
  return (
    <Flex vertical style={{ border: `1px solid ${borderColorSplit}`, padding: 16, borderRadius: 8 }}>
      <Typography.Title level={5}>Execution results</Typography.Title>

      <Form.Item name={[ 'executionResults', 'resultSubPop' ]} valuePropName="checked" style={{ marginBottom: 0 }}>
        <Checkbox disabled={viewMode || !results?.resultSubPop}>Summary Sub set</Checkbox>
      </Form.Item>

      <Form.Item name={[ 'executionResults', 'resultSubPopChrm' ]} valuePropName="checked" style={{ marginBottom: 0 }}>
        <Checkbox disabled={viewMode || !results?.resultSubPopChrm}>Detailed Sub set</Checkbox>
      </Form.Item>

      <Form.Item name={[ 'executionResults', 'resultSuperPop' ]} valuePropName="checked" style={{ marginBottom: 0 }}>
        <Checkbox disabled={viewMode || !results?.resultSuperPop}>Summary Super set</Checkbox>
      </Form.Item>

      <Form.Item name={[ 'executionResults', 'resultSuperPopChrm' ]} valuePropName="checked" style={{ marginBottom: 0 }}>
        <Checkbox disabled={viewMode || !results?.resultSuperPopChrm}>Detailed Super set</Checkbox>
      </Form.Item>

      <Form.Item name={[ 'executionResults', 'resultSvgData' ]} valuePropName="checked" style={{ marginBottom: 0 }}>
        <Checkbox disabled={viewMode || !results?.resultSvgData}>SVG data</Checkbox>
      </Form.Item>

      <Form.Item name={[ 'executionResults', 'resultPrsData' ]} valuePropName="checked" style={{ marginBottom: 0 }}>
        <Checkbox disabled={viewMode || !results?.resultPrsData}>PRS data</Checkbox>
      </Form.Item>

      <Form.Item name={[ 'executionResults', 'resultPrsTechData' ]} valuePropName="checked" style={{ marginBottom: 0 }}>
        <Checkbox disabled={viewMode || !results?.resultPrsTechData}>PRS tech data</Checkbox>
      </Form.Item>

      <Form.Item name={[ 'executionResults', 'resultPrsQc' ]} valuePropName="checked" style={{ marginBottom: 0 }}>
        <Checkbox disabled={viewMode || !results?.resultPrsQc}>PRS QC data</Checkbox>
      </Form.Item>
    </Flex>
  );
};

export default ExecutionResultsForm;
